export default __webpack_public_path__ + "static/media/close-icon-red.e2964703.svg";